/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PAYMENT_QUEUE } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import toast, { ToastBar } from "react-hot-toast";
import { StorageModule } from "@vlinder-web/storage-module-react";
import moment from "moment";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPollingMethods extends IPluginMethodMap {
  getPolling(args: any): Promise<any>;
}
export class PollingService implements IAgentPlugin {
  readonly methods: IPollingMethods;

  constructor() {
    this.methods = {
      getPolling: this.getPolling.bind(this),
    };
  }

  async getPolling(args: any) {
    log.info(`in getPolling service`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const sessionData = storageService.get("distCenterData", "local");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PAYMENT_QUEUE,
          variables: {
            distCenter: {
              _id: sessionData?.distCenter,
            },

            queueType: "payment",
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`payment queue data`, res.data);
          // toast.success("Payment Queue Updated");
          return {
            ...this.formatPaymentQueueData(res.data.getQueueFromVQMS),
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {...(config || {})}
  }

  private formatPaymentQueueData = (data: any) => {
    const distCenterData = storageService.get("distCenterData", "local");
    let vipList: any[] = [];
    let nonVipList: any[] = [];
    let activeUser: any[] = [];
    let isLocked: boolean = false;
    let isCalledOut: boolean = false;
    data &&
      data?.parsed &&
      Array.isArray(data?.parsed) &&
      data?.parsed.length > 0 &&
      data?.parsed.forEach((item: any) => {
        if (
          item?.lockedByPayCounter &&
          item?.lockedByPayCounter === distCenterData?.paymentCounter
        ) {
          // if (!item?.isGroup) {
          let _userInfo =
            item?.boxData &&
            Array.isArray(item?.boxData) &&
            item?.boxData?.length > 0 &&
            item?.boxData[0];
          activeUser.push({
            name: _userInfo?.fullName,
            image: "https://www.w3schools.com/howto/img_avatar.png",
            masqId: _userInfo?.masqID,
            tokenTitle: "Token No",
            token:
              item?.tokenKey && item?.tokenKey.includes("__")
                ? item?.tokenKey.split("__")[1]
                : item?.tokenKey,
            waitingTimeTitle: "Waiting Time",
            waitingTime: this.formatWaitingTime(item?.createdOn),
            listItems: [],
            tokenKey: item?.tokenKey,
          });
          //}
          isLocked = item?.lockedByPayCounter ? true : false;
          isCalledOut = item?.isCalledOutByPayCounter;

          if (item.isVipToken) {
            vipList.push({
              ...item,
              appCardId: item?.tokenKey,
              appCardImage: "",
              appCardTitle: item?.isGroup
                ? ""
                : this.formatAppCardTitle(item?.boxData),
              appCardDescription: this.formatCardDescription(item?.boxData),
              appCardList: this.formatAppCardList(item),
              timeStamp: this.formatWaitingTime(item?.createdOn),
            });
          } else {
            nonVipList.push({
              ...item,
              appCardId: item?.tokenKey,
              appCardImage: "",
              appCardTitle: item?.isGroup
                ? ""
                : this.formatAppCardTitle(item?.boxData),
              appCardDescription: this.formatCardDescription(item?.boxData),
              appCardList: this.formatAppCardList(item),
              timeStamp: this.formatWaitingTime(item?.createdOn),
            });
          }
        }
        if (item.isVipToken && !item?.lockedByPayCounter) {
          vipList.push({
            ...item,
            appCardId: item?.tokenKey,
            appCardImage: "",
            appCardTitle: item?.isGroup
              ? ""
              : this.formatAppCardTitle(item?.boxData),
            appCardDescription: this.formatCardDescription(item?.boxData),
            appCardList: this.formatAppCardList(item),
            timeStamp: this.formatWaitingTime(item?.createdOn),
          });
        } else if (!item?.lockedByPayCounter) {
          nonVipList.push({
            ...item,
            appCardId: item?.tokenKey,
            appCardImage: "",
            appCardTitle: item?.isGroup
              ? ""
              : this.formatAppCardTitle(item?.boxData),
            appCardDescription: this.formatCardDescription(item?.boxData),
            appCardList: this.formatAppCardList(item),
            timeStamp: this.formatWaitingTime(item?.createdOn),
          });
        }
      });
    return {
      vipList: this.sortTokens(vipList),
      nonVipList: this.sortTokens(nonVipList),
      activeUser,
      isLocked,
      isCalledOut,
    };
  };

  private sortTokens = (tokens: any) => {
    const _tokens = tokens.sort((a: any, b: any) => {
      return b.timeStamp - a.timeStamp;
    });
    console.log(`sorted tokens`, _tokens);
    return _tokens;
  };

  private formatAppCardTitle = (data: any) => {
    let title = "";
    title =
      data && Array.isArray(data) && data.length > 0 ? data[0]?.fullName : "";
    return title;
  };

  private formatCardDescription = (data: any) => {
    let description = "";
    description =
      data && Array.isArray(data) && data.length > 0 ? data[0]?.masqID : "";
    return description;
  };

  private formatAppCardList = (data: any) => {
    let list: any[] = [];
    if (data?.tokenKey) {
      list.push({
        name: "Token",
        value: this.formatToken(data?.tokenKey),
      });
    }
    if (data?.createdOn) {
      list.push({
        name: "Waiting Time",
        value: this.formatWaitingTime(data?.createdOn),
      });
    }
    return list;
  };

  private formatToken = (token: string) => {
    let formattedToken = "";
    if (token) {
      formattedToken = token?.split("__")[1];
    }
    return formattedToken;
  };

  private formatWaitingTime = (createdOn: string) => {
    let waitingTime = null;
    if (createdOn) {
      let currentData = moment();
      let arrivalTime = moment(createdOn);
      waitingTime = currentData.diff(arrivalTime, "seconds");

      //moment convert seconds to HH:mm format
      waitingTime = moment.utc(waitingTime * 1000).format("HH:mm");
    }
    return waitingTime;
  };
}
